<div [ngClass]="shellClasses">
  <div class="data-table-scroll">
    <table mat-table [dataSource]="dataSource" class="app-data-table" [ngClass]="tableClass">
      <ng-container *ngIf="selectionColumn" [matColumnDef]="selectionColumnName">
        <th mat-header-cell *matHeaderCellDef class="data-table-select-col">
          <mat-checkbox
            *ngIf="!selectionColumn.hideHeaderCheckbox"
            (click)="$event.stopPropagation()"
            (change)="onToggleAll()"
            [checked]="isAllSelected()"
            [indeterminate]="isSelectionIndeterminate()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="data-table-select-col">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="onToggleRow(row, $event)"
            [disabled]="!isRowSelectable(row)"
            [checked]="isRowSelected(row)">
          </mat-checkbox>
        </td>
        <td mat-footer-cell *matFooterCellDef class="data-table-select-col"></td>
      </ng-container>

      <ng-content select="[matColumnDef]"></ng-content>

      <ng-container *ngIf="actionColumn" [matColumnDef]="actionColumnName">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="data-table-action-col"
          [class.text-right]="actionColumn.align === 'end'"
          [class.text-center]="actionColumn.align === 'center'">
        </th>
        <td
          mat-cell
          *matCellDef="let row; let i = index"
          class="data-table-action-col"
          [class.text-right]="actionColumn.align === 'end'"
          [class.text-center]="actionColumn.align === 'center'">
          <div class="data-table-actions">
            <ng-container *ngFor="let action of actionColumn.actions">
              <ng-container *ngIf="isActionVisible(action, row)">
                <button
                  *ngIf="(action.variant || 'stroked') === 'icon'; else nonIconAction"
                  mat-icon-button
                  [color]="action.color || undefined"
                  [disabled]="isActionDisabled(action, row)"
                  [ngClass]="getActionClass(action, row)"
                  (click)="onActionClick(action, row, i, $event)">
                  <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
                </button>

                <ng-template #nonIconAction>
                  <button
                    *ngIf="(action.variant || 'stroked') === 'flat'; else strokedAction"
                    mat-flat-button
                    [color]="action.color || undefined"
                    [disabled]="isActionDisabled(action, row)"
                    [ngClass]="getActionClass(action, row)"
                    (click)="onActionClick(action, row, i, $event)">
                    <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
                    <span *ngIf="action.label">{{ action.label }}</span>
                  </button>
                </ng-template>

                <ng-template #strokedAction>
                  <button
                    mat-stroked-button
                    [color]="action.color || undefined"
                    [disabled]="isActionDisabled(action, row)"
                    [ngClass]="getActionClass(action, row)"
                    (click)="onActionClick(action, row, i, $event)">
                    <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
                    <span *ngIf="action.label">{{ action.label }}</span>
                  </button>
                </ng-template>
              </ng-container>
            </ng-container>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef class="data-table-action-col"></td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell data-table-empty-cell" [attr.colspan]="colspan">
          <ng-container *ngIf="loading; else emptyStateBlock">
            <ng-container *ngIf="loadingStateTemplate; else defaultLoadingState"
              [ngTemplateOutlet]="loadingStateTemplate">
            </ng-container>
          </ng-container>

          <ng-template #emptyStateBlock>
            <ng-container *ngIf="emptyStateTemplate; else defaultEmptyState"
              [ngTemplateOutlet]="emptyStateTemplate">
            </ng-container>
          </ng-template>

          <ng-template #defaultLoadingState>
            <div class="data-table-state data-table-state--loading">
              <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
              <span>{{ loadingMessage }}</span>
            </div>
          </ng-template>

          <ng-template #defaultEmptyState>
            <div class="data-table-state">
              <mat-icon>{{ emptyIcon }}</mat-icon>
              <span>{{ emptyMessage }}</span>
            </div>
          </ng-template>
        </td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: stickyHeader"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; let i = index"
        [ngClass]="resolveRowClass(row, i)"
        [class.data-table-row--clickable]="rowClickable"
        (click)="handleRowClick(row, i)">
      </tr>
    </table>
  </div>

  <mat-paginator
    *ngIf="showPaginator"
    [length]="length"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="showFirstLastButtons"
    (page)="emitPageChange($event)">
  </mat-paginator>
</div>
